import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";

import { DisplayMusicByToken } from "@/components/DisplayMusic";
export default function PickupDisplay() {
  const { token } = useParams();
  const [d, setD] = useState(null);
  useEffect(() => {
    const load = () => api.get(`/displays/public/${token}`).then((r) => setD(r.data)).catch(() => {});
    load();
    const t = setInterval(load, 4000);
    return () => clearInterval(t);
  }, [token]);
  if (!d) return <div className="min-h-screen bg-black text-[#A8A398] flex items-center justify-center">Lade …</div>;
  return (
    <>
      <DisplayMusicByToken token={token} autoStart hideToggle />
      <div className="min-h-screen bg-black text-[#F5F0E6] p-10">
      <div className="text-center mb-10">
        <div className="text-xs uppercase tracking-[0.4em] text-[#A8A398]">Abholung</div>
        <div className="font-heading text-6xl text-[#D4AF37] mt-2">Deine Bestellung ist bereit</div>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 max-w-5xl mx-auto">
        {(d.ready || []).map((o, i) => (
          <div key={i} className="card-lux p-8 text-center gold-glow border-[#D4AF37]/40">
            <div className="text-[10px] uppercase tracking-[0.32em] text-[#A8A398]">Nummer</div>
            <div className="font-heading text-6xl text-[#D4AF37] mt-2">{o.number}</div>
            {o.guest_name && <div className="text-sm text-[#A8A398] mt-2">{o.guest_name}</div>}
          </div>
        ))}
        {!d.ready?.length && (
          <div className="col-span-full text-center text-[#A8A398] text-2xl font-heading py-20">Aktuell keine Bestellungen bereit.</div>
        )}
      </div>
    </div>
  
    </>);
}
